/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './treatment-radiation-technique.reducer';

export const TreatmentRadiationTechniqueDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const treatmentRadiationTechniqueEntity = useAppSelector(state => state.treatmentRadiationTechnique.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="treatmentRadiationTechniqueDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.treatmentRadiationTechnique.detail.title">TreatmentRadiationTechnique</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.treatmentRadiationTechnique.id">Id</Translate>
            </span>
          </dt>
          <dd>{treatmentRadiationTechniqueEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.treatmentRadiationTechnique.active">Active</Translate>
            </span>
          </dt>
          <dd>{treatmentRadiationTechniqueEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.treatmentRadiationTechnique.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{treatmentRadiationTechniqueEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.treatmentRadiationTechnique.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{treatmentRadiationTechniqueEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.treatmentRadiationTechnique.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{treatmentRadiationTechniqueEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.treatmentRadiationTechnique.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{treatmentRadiationTechniqueEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentRadiationTechnique.radiationSession">Radiation Session</Translate>
          </dt>
          <dd>{treatmentRadiationTechniqueEntity.radiationSession ? treatmentRadiationTechniqueEntity.radiationSession.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/treatment-radiation-technique" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/treatment-radiation-technique/${treatmentRadiationTechniqueEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TreatmentRadiationTechniqueDetail;
